import { Pin, Bird, Briefcase, Mail, Link as LinkIcon, Share2 } from "lucide-react";
import toast from "react-hot-toast";

const ShareBar = ({ url, title, imageUrl }) => {
    const enc = encodeURIComponent;
  
    const links = [
      {
        label: "Share on Facebook",
        href: `https://www.facebook.com/sharer/sharer.php?u=${enc(url)}`,
        icon: Share2,
      },
      {
        label: "Pin on Pinterest",
        href: imageUrl
          ? `https://pinterest.com/pin/create/button/?url=${enc(url)}&media=${enc(
              imageUrl
            )}&description=${enc(title)}`
          : null,
        icon: Pin,
      },
      {
        label: "Post on X / Twitter",
        href: `https://twitter.com/intent/tweet?url=${enc(url)}&text=${enc(
          title
        )}`,
        icon: Bird,
      },
      {
        label: "Share on LinkedIn",
        href: `https://www.linkedin.com/shareArticle?mini=true&url=${enc(
          url
        )}&title=${enc(title)}`,
        icon: Briefcase,
      },
      {
        label: "Share via Email",
        href: `mailto:?subject=${enc(title)}&body=${enc(url)}`,
        icon: Mail,
      },
    ].filter((l) => l.href);
  
    const handleCopy = () => {
      navigator.clipboard.writeText(url);
      toast.success("Link copied!");
    };
  
    return (
      <div className="flex items-center gap-3 flex-wrap">
        <span className="text-xs uppercase tracking-widest text-stone-400 font-sourcesans mr-1">
          Share
        </span>
        {links.map(({ label, href, icon: Icon }) => (
          <a
            key={label}
            href={href}
            title={label}
            aria-label={label}
            target={href.startsWith("http") ? "_blank" : undefined}
            rel={href.startsWith("http") ? "noopener noreferrer" : undefined}
            className="p-2 rounded-full text-stone-500 hover:text-[#BC3F4A] hover:bg-[#BC3F4A]/8 transition"
          >
            <Icon size={15} />
          </a>
        ))}
        <button
          onClick={handleCopy}
          title="Copy link"
          aria-label="Copy link"
          className="p-2 rounded-full text-stone-500 hover:text-[#BC3F4A] hover:bg-[#BC3F4A]/8 transition"
        >
          <LinkIcon size={15} />
        </button>
      </div>
    );
  };
  

  export default ShareBar;